/**
 * @generated SignedSource<<50516a9c5b7b2ce964cf48851ab35305>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StartDevicePairingInput = {
  clientMutationId?: string | null | undefined;
  name: string;
};
export type OpsDevicesPageStartMutation$variables = {
  input: StartDevicePairingInput;
};
export type OpsDevicesPageStartMutation$data = {
  readonly startDevicePairing: {
    readonly pairing: {
      readonly expiresAt: any;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly pairingUrl: string | null | undefined;
    readonly qrSvg: string | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsDevicesPageStartMutation = {
  response: OpsDevicesPageStartMutation$data;
  variables: OpsDevicesPageStartMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StartDevicePairingPayload",
    "kind": "LinkedField",
    "name": "startDevicePairing",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DevicePairing",
        "kind": "LinkedField",
        "name": "pairing",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expiresAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pairingUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "qrSvg",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsDevicesPageStartMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsDevicesPageStartMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "279261c8fadbf5e57c953d321c536569",
    "id": null,
    "metadata": {},
    "name": "OpsDevicesPageStartMutation",
    "operationKind": "mutation",
    "text": "mutation OpsDevicesPageStartMutation(\n  $input: StartDevicePairingInput!\n) {\n  startDevicePairing(input: $input) {\n    pairing {\n      id\n      name\n      expiresAt\n    }\n    pairingUrl\n    qrSvg\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d79d291825433584bd45efdf63cfe899";

export default node;
